import { EditorStarterItem } from '../../items/item-type';
import { isTextItem, TextItem } from '../../items/text/text-item-type';
import { measureAutoWrappedHeight } from '../hydrate/hydrate-editor-state-utils';

export const measureTextItemHeight = (
  item: TextItem,
  width: number,
): number => {
  const measured = measureAutoWrappedHeight({
    text: item.text,
    width,
    fontSize: item.fontSize,
    lineHeight: item.lineHeight,
    letterSpacing: item.letterSpacing,
    fontFamily: item.fontFamily,
    fontStyle: item.fontStyle,
  });
  return measured ?? item.height;
};

export const updateItemWidth = ({
  item,
  width,
  stopTextEditing,
}: {
  item: EditorStarterItem;
  width: number;
  stopTextEditing: boolean;
}) => {
  const textProps = isTextItem(item)
    ? {
        height: measureTextItemHeight(item, width),
        ...(stopTextEditing ? { resizeOnEdit: false } : {}),
      }
    : {};

  return {
    ...item,
    width,
    ...textProps,
  } as EditorStarterItem;
};

export const updateItemHeight = ({
  item,
  height,
  stopTextEditing,
}: {
  item: EditorStarterItem;
  height: number;
  stopTextEditing: boolean;
}) => {
  return {
    ...item,
    height,
    ...(isTextItem(item) && stopTextEditing ? { resizeOnEdit: false } : {}),
  } as EditorStarterItem;
};
